var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"slide-fade"}},[(_vm.isVisible)?_c('alert',{staticClass:"absolute bottom-0 right-0 mb-5 mr-5",staticStyle:{"width":"300px"},attrs:{"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }